import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { banners } from "@/mocks/movies";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % banners.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const goTo = (target: number) => {
    setIndex((target + banners.length) % banners.length);
  };

  const current = banners[index];

  return (
    <section className="relative w-full h-[480px] md:h-[620px] -mt-16 md:-mt-[72px] overflow-hidden">
      {banners.map((banner, i) => (
        <div
          key={banner.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === index ? "opacity-100" : "opacity-0"
          }`}
          aria-hidden={i !== index}
        >
          <img
            src={banner.image}
            alt={`${banner.title} 焦点海报`}
            title={`${banner.title} 高清影视焦点推荐`}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/50 to-background-50/30" />
      <div className="absolute inset-0 bg-gradient-to-r from-background-50/90 via-background-50/40 to-transparent" />

      <div className="relative z-10 h-full w-full px-4 md:px-8 flex items-end pb-12 md:pb-20">
        <div className="max-w-2xl pt-24 md:pt-32">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold mb-4 animate-fade-in">
            <i className="ri-fire-fill" />
            {current.tag}
          </span>
          <h2
            key={current.id}
            className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950 leading-tight animate-fade-up"
          >
            {current.title}
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 max-w-xl leading-relaxed animate-fade-up">
            {current.subtitle}
          </p>
          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to={`/detail/${current.movieId}`}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-fill text-base" />
              查看详情
            </Link>
            <Link
              to="/#latest"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50/10 text-foreground-950 text-sm font-semibold border border-background-300/60 hover:bg-background-200/60 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-compass-3-line text-base" />
              探索更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute z-10 bottom-6 md:bottom-8 right-4 md:right-8 flex items-center gap-2">
        <button
          type="button"
          onClick={() => goTo(index - 1)}
          className="w-9 h-9 rounded-full bg-background-100/70 border border-background-300/60 text-foreground-900 flex items-center justify-center hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-colors cursor-pointer"
          aria-label="上一张"
        >
          <i className="ri-arrow-left-s-line text-lg" />
        </button>
        <button
          type="button"
          onClick={() => goTo(index + 1)}
          className="w-9 h-9 rounded-full bg-background-100/70 border border-background-300/60 text-foreground-900 flex items-center justify-center hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-colors cursor-pointer"
          aria-label="下一张"
        >
          <i className="ri-arrow-right-s-line text-lg" />
        </button>
      </div>

      <div className="absolute z-10 bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {banners.map((banner, i) => (
          <button
            key={banner.id}
            type="button"
            onClick={() => goTo(i)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              i === index ? "w-8 bg-primary-400" : "w-4 bg-background-400/70"
            }`}
            aria-label={`切换到第 ${i + 1} 张`}
          />
        ))}
      </div>
    </section>
  );
}